import React from "react";
import { Route, Redirect } from "react-router-dom";
import { isTokenValidDist } from "../Utils/auth";

const ProtectedRouteDist = ({ children, ...rest }) => {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        isTokenValidDist() ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

export default ProtectedRouteDist;
